// import React, { useState } from "react";
// import { IoColorPalette } from "react-icons/io5";
// import whatsAppStatusColors from "../../../constant/constants";
// import { useAppSelector } from "../../../redux/ReduxType";
// import { useMakeRequest } from "../../../hooks/useMakeRequest";
// import { STATUS_URL } from "../../../constant/resource";
// import { toast } from "sonner";
// import LoaderSpinner from "../../molecules/Loader/Loader.spinner";

// const TextStatus = ({ close }: { close: () => void }) => {
//   const [currentColorIndex, setCurrentColorIndex] = useState(0);
//   const [currentText, setCurrentText] = useState("");
//   const User = useAppSelector((state) => state.user);
//   const makeRequest = useMakeRequest();
//   const [loading, setLoading] = useState(false);

//   const handleColor = () => {
//     setCurrentColorIndex((prev) =>
//       prev === whatsAppStatusColors.length - 1 ? 0 : prev + 1
//     );
//   };

//   const currentColor = whatsAppStatusColors[currentColorIndex];

//   const handleChange = (e: any) => {
//     const value = e.target.value;
//     setCurrentText(value);
//   };

//   const handleSubmit = () => {
//     if (currentText === "") return;
//     const payload = {
//       author: User?._id,
//       text: currentText,
//       statusType: "text",
//       backgroundColor: currentColor?.bg,
//       textColor: currentColor?.text,
//     };

//     try {
//       setLoading(true);
//       const onSuccess = (data: any) => {
//         toast.success("Done");

//         // --- trigger refetch-------

//         // console.log(data);
//       };
//       const onFailure = (data: any) => {
//         toast.error("Error try again later");
//       };
//       const onFinal = () => {
//         setLoading(false);
//         setCurrentText("");
//         close();
//       };
//       makeRequest(STATUS_URL, "POST", payload, onSuccess, onFailure, onFinal);
//     } catch (error) {
//       console.error("Error", error);
//       toast.error("Error try again later");
//       setLoading(false);
//       close();
//     }
//   };

//   return (
//     <div
//       className={`w-full h-[80%] rounded-lg relative flex flex-col items-center justify-center`}
//     >
//       <div>
//         <IoColorPalette
//           onClick={handleColor}
//           className="w-6 h-6 absolute top-0 right-0 cursor-pointer"
//         />
//       </div>
//       <form
//         style={{
//           backgroundColor: currentColor.bg,
//           color: currentColor.text,
//         }}
//         onSubmit={handleSubmit}
//         className="h-full w-full flex items-center justify-center rounded-sm p-2"
//       >
//         <input
//           className="w-full text-center p-2 outline-none bg-inherit"
//           type="text"
//           placeholder="Make it inspiring"
//           onChange={handleChange}
//           value={currentText}
//         />
//       </form>
//       <button
//         className="bg-darkBg px-4 py-2 rounded-sm text-white mt-2"
//         type="submit"
//         onClick={handleSubmit}
//       >
//         {loading ? <LoaderSpinner color={"white"} /> : "Submit"}
//       </button>
//     </div>
//   );
// };

// export default TextStatus;

// ------- version 2 --------
import React, { useState } from "react";
import { IoColorPalette } from "react-icons/io5";
import whatsAppStatusColors from "../../../constant/constants";
import { useAppSelector } from "../../../redux/ReduxType";
import { useMakeRequest } from "../../../hooks/useMakeRequest";
import { STATUS_URL } from "../../../constant/resource";
import { toast } from "sonner";
import LoaderSpinner from "../../molecules/Loader/Loader.spinner";

interface TextStatusProps {
  close: () => void;
}

const TextStatus: React.FC<TextStatusProps> = ({ close }) => {
  const [currentColorIndex, setCurrentColorIndex] = useState(0);
  const [currentText, setCurrentText] = useState("");
  const [loading, setLoading] = useState(false);

  const User = useAppSelector((state) => state.user);
  const makeRequest = useMakeRequest();

  const handleColorChange = () => {
    setCurrentColorIndex((prevIndex) =>
      prevIndex === whatsAppStatusColors.length - 1 ? 0 : prevIndex + 1
    );
  };

  const currentColor = whatsAppStatusColors[currentColorIndex];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentText(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!currentText.trim()) return;

    const payload = {
      author: User?._id,
      text: currentText,
      statusType: "text",
      backgroundColor: currentColor?.bg,
      textColor: currentColor?.text,
    };

    setLoading(true);

    makeRequest(
      STATUS_URL,
      "POST",
      payload,
      () => {
        toast.success("Status posted successfully!");
        setCurrentText("");
      },
      () => {
        toast.error("Failed to post status. Try again later.");
      },
      () => {
        setLoading(false);
        close();
      }
    );
  };

  return (
    <div className="w-full h-[200px] mt-5 rounded-lg relative flex flex-col items-center justify-center">
      <IoColorPalette
        onClick={handleColorChange}
        className="w-6 h-6 absolute top-2 right-2 cursor-pointer"
        aria-label="Change background color"
      />

      <form
        style={{ backgroundColor: currentColor.bg, color: currentColor.text }}
        onSubmit={handleSubmit}
        className="h-full w-full flex flex-col items-center justify-center rounded-sm p-2"
      >
        <input
          className="w-full text-center p-2 outline-none bg-inherit"
          type="text"
          placeholder="Make it inspiring..."
          onChange={handleInputChange}
          value={currentText}
          aria-label="Enter text status"
        />
        <button
          className="bg-gray-800 absolute bottom-0 left-[45%] px-4 py-2 rounded-sm text-white mt-2"
          type="submit"
          disabled={loading}
        >
          {loading ? <LoaderSpinner color="white" /> : "Submit"}
        </button>
      </form>
    </div>
  );
};

export default TextStatus;
